<template>
    <div v-if="protocolTypeList.length>0">
        <content-block title="是否关联补充协议"  isRequired>
            <div>
                <label for="connectProtocol1"><input id="connectProtocol1" type="radio" @change="changeConnect()" v-model="connectProtocol" :value="true"> 是</label>
                <label for="connectProtocol2"><input id="connectProtocol2" type="radio" @change="changeConnect()" v-model="connectProtocol" :value="false"> 否</label>
            </div>
            <span v-show="validateErrors.has('tab1','model.supplierProtocolRule')" class="help is-danger">请补充完整下方所需关联协议</span>
        </content-block>
        <content-block v-if="connectProtocol" title="关联协议" isRequired>
            <div v-for="(block, index) in selectProtocolTypeList">
                <div style="position: relative;">
                    <div class="step-line"></div>
                    <div class="row step-content">
                        <div class="ticket-step ticket-step-active col-sm-1">1</div>
                        <span class="col-sm-1 no-padding-right">协议类型</span>
                        <v-select v-if="protocolTypeList.length > 1" class="col-sm-6" v-model="selectProtocolTypeList[index]" placeholder="请选择协议类型" >
                            <v-option
                                    v-for="item in protocolTypeList"
                                    :label="item.name"
                                    :value="item.key"
                                    :key="item.key"
                                    :disabled="selectProtocolTypeList.indexOf(item.key) !== -1"
                            >
                            </v-option>
                        </v-select>
                        <span v-else-if="protocolTypeList.length === 1" class="col-sm-6">{{protocolTypeList[0].name}}</span>
                        <span>
                            <button
                                    class="btn btn-link btn-xs"
                                    @click="addProtocolType()"
                                    v-if="selectProtocolTypeList.length < protocolTypeList.length"
                            >
                                <i class="icon-button icon-plus"></i>
                            </button>
                            <button
                                    class="btn btn-link btn-xs"
                                    v-if="selectProtocolTypeList.length > 1"
                                    @click="removeProtocolType(index)"
                            >
                                <i class="icon-button delete icon-cancel"></i>
                            </button>
                        </span>
                    </div>
                    <div class="row step-content">
                        <div class="ticket-step ticket-step-active col-sm-1">2</div>
                        <span class="col-sm-1 no-padding-right">协议名称</span>
                        <v-input v-if="selectProtocolTypeList[index] === ''" class="col-sm-6" :disabled="true"></v-input>
                        <span v-else-if="protocolInfo[selectProtocolTypeList[index]].length === 1" class="col-sm-6">{{protocolInfo[selectProtocolTypeList[index]][0].ruleName}}</span>
                        <v-select
                                v-model="tempMsg"
                                @change="addProtocol"
                                v-else-if="protocolInfo[selectProtocolTypeList[index]].length > 1"
                                class="col-sm-6"
                                placeholder="请选择协议名称" >
                            <v-option
                                    v-for="item in protocolInfo[selectProtocolTypeList[index]]"
                                    :label="item.ruleName"
                                    :value="`${selectProtocolTypeList[index]}~||~${JSON.stringify(item)}`"
                                    :key="item.ruleId"
                                    :disabled="typeof item.disabled !== 'undefined' && item.disabled"
                            >
                            </v-option>
                        </v-select>
                    </div>
                </div>
                <div class="row step-content tags"
                     v-if="selectProtocolTypeList[index] !== ''
                     && supplierProtocolRule[selectProtocolTypeList[index]].length > 0
                     && protocolInfo[selectProtocolTypeList[index]].length > 1">
                    <div class="col-sm-10 col-md-offset-1">
                        <v-tag
                                v-for="(tag, tagIndex) in supplierProtocolRule[selectProtocolTypeList[index]]"
                                :type="'success'"
                                :key="tag.ruleName"
                                :close-transition="false"
                                @close="handleTagClose(tagIndex, selectProtocolTypeList[index])"
                                class="tag"
                                :closable="true"
                        >
                            {{tag.ruleName}}
                        </v-tag>
                    </div>
                </div>
            </div>
        </content-block>
    </div>
</template>
<script>
//todo: 确定禁止修改的情况，并添加
import ContentBlock from 'components/content-block/index.vue'
import { getprotocol } from 'api/ticket'
export default {
    components: {
        ContentBlock
    },
    data () {
        return {
            tempMsg:'',
            protocolInfo: null,
            connectProtocol: false,
            protocolTypeList: [],
            selectProtocolTypeList:['']
        }
    },
    props: {
        extra: {
            type: Object,
            required: true
        },
        supplierProtocolRule: {
            type: Object,
            required: true
        },
        loaded: Boolean
    },
    methods: {
        resetDisable: function () {
            for(let key of Object.keys(this.protocolInfo)) {
                for (let proto of this.protocolInfo[key]) {
                    proto.disabled = false
                }
            }
        },
        addProtocol: function (protocolInfo) {
            const [key, protocolStr] = protocolInfo.split('~||~')
            if (key && this.supplierProtocolRule[key]) {
                const protocol = JSON.parse(protocolStr)
                this.supplierProtocolRule[key].push(protocol)
                this.tempMsg = ''
                // disable掉已经选中项
                for (let i = 0; i < this.protocolInfo[key].length; i++) {
                    if (this.protocolInfo[key][i].ruleId === protocol.ruleId) {
                        this.protocolInfo[key][i].disabled = true
                    }
                }
            }
        },
        handleTagClose: function (index, key) {
            const protocol = this.supplierProtocolRule[key][index]
            this.supplierProtocolRule[key].splice(index, 1)
            // 去掉禁用
            for (let i = 0; i < this.protocolInfo[key].length; i++) {
                if (this.protocolInfo[key][i].ruleId === protocol.ruleId) {
                    delete (this.protocolInfo[key][i].disabled)
                }
            }
        },
        addProtocolType: function () {
            this.selectProtocolTypeList.push('')
        },
        removeProtocolType: function (index) {
            const protocol = this.selectProtocolTypeList.splice(index, 1).pop()
            // 同时要清空相应的协议列表
            this.$set(this.supplierProtocolRule, protocol, [])
        },
        initData: function () {
            if (this.loaded) {
                for (const key of Object.keys(this.supplierProtocolRule)) {
                    if (this.supplierProtocolRule[key].length > 0) {
                        this.connectProtocol = true
                        if (this.selectProtocolTypeList.length === 1 && this.selectProtocolTypeList[0] === '') {
                            this.selectProtocolTypeList = []
                        }
                        if (this.selectProtocolTypeList.indexOf(key) === -1) {
                            this.selectProtocolTypeList.push(key)
                        }
                        // 将已经被选择的协议在列表中disable掉
                        for (const obj of this.supplierProtocolRule[key]) {
                            for (const item of this.protocolInfo[key]) {
                                if (obj.ruleId === item.ruleId) {
                                    item.disabled = true
                                }
                            }
                        }
                    }
                }
            }
        },
        changeConnect: function () {
            // 选择否以后清空所有数据
            if (!this.connectProtocol) {
                //清空diabled
                this.resetDisable()
                this.selectProtocolTypeList = ['']
                for (let key of Object.keys(this.supplierProtocolRule)) {
                    this.supplierProtocolRule[key] = [];
                }
            } else { // 选择是的时候，如果只有一种协议，且该种协议下只有一个协议，在此手动添加
                if (this.protocolTypeList.length === 1) {
                    this.selectProtocolTypeList = [this.protocolTypeList[0].key]
                }
            }
            //当选择是否关联的时候，相应处理报错状态
            this.checkEmpty()
        },
        checkEmpty: function () {
            // 手动控制报错
            if (!this.connectProtocol) {
                this.validateErrors.removeAll('tab1', 'model.supplierProtocolRule')
            } else {
                let empty = true
                if (this.selectProtocolTypeList.length > 0) {
                    let allDone = true
                    for (const type of this.selectProtocolTypeList) {
                        if (type === '') {
                            allDone = false
                            break
                        }
                        if (this.supplierProtocolRule[type].length <= 0) {
                            allDone = false
                            break
                        }
                    }
                    if (allDone) {
                        empty = false
                    }
                }
                if (empty) {
                    this.validateErrors.add('tab1', {
                        key: 0,
                        modelName: 'model.supplierProtocolRule',
                        showError: false,
                        rule: 'required'
                    })
                } else {
                    this.validateErrors.removeAll('tab1', 'model.supplierProtocolRule')
                }
            }
        }
    },
    watch:{
        loaded: function () {
            this.initData()
        },
        selectProtocolTypeList: function () {
            // 处理当某个协议类型下只有一个协议且关联协议选是的时候，自动选中那一个协议
            if (this.selectProtocolTypeList.length > 0) {
                for (const type of this.selectProtocolTypeList) {
                    if (type !== '' && this.protocolInfo[type].length === 1 && this.connectProtocol) {
                        this.$set(this.supplierProtocolRule, type, [this.protocolInfo[type][0]])
                    }
                }
            }
        },
        // 直接watch supplierProtocolRule watch不到。。。。。
        'supplierProtocolRule.rebateProtocols': function () {
            this.checkEmpty()
        },
        'supplierProtocolRule.packageProtocols': function () {
            this.checkEmpty()
        }
    },
    async beforeMount () {
        // 获取补充协议
        if (this.extra.supplierId) {
            try {
                const res = await getprotocol(this.extra.supplierId, this.extra.contractNum)
                if (res && res.data && res.data.supplierProtocolRule) {
                    this.protocolInfo = res.data.supplierProtocolRule
                    //这里写死两种协议，以后增加新协议需与后端协调整体修改
                    //这里重新整理后端数据，方便前端展示
                    //因为有try catch，直接判断length
                    if (this.protocolInfo.rebateProtocols.length > 0) {
                        this.protocolTypeList.push({
                            key: 'rebateProtocols',
                            name: '返佣协议',
                        })
                    }
                    if (this.protocolInfo.packageProtocols.length > 0) {
                        this.protocolTypeList.push({
                            key: 'packageProtocols',
                            name: '包票协议',
                        })
                    }
                    if (this.protocolTypeList.length === 1) {
                        this.selectProtocolTypeList = [this.protocolTypeList[0].key]
                    }
                    this.initData()
                }
            } catch (e) {
                console.log(e)
            }
        }
    }
}
</script>
<style scoped>
    .ticket-step {
        width: 28px;
        height: 28px;
        border-radius: 50%;
        background-color: #d3dce6;
        display: inline-block;
        text-align: center;
        vertical-align: top;
        font-size: 14px;
        line-height: 28px;
        color: #fff;
        padding: 0 !important;
        top: 4px;
    }

    .ticket-step-active {
        background-color: #3DC6B6;
    }

    .step-line {
        height: 75%;
        position: absolute;
        border-left: dashed 2px #3DC6B6;
        left: -1px;
        top: 9%;
    }

    .step-line span, .step-line .el-select {
        margin-top: -4px;
        padding-right: 0;
    }

    .step-line .step-content:last-child {
        margin-bottom: -5px;
    }

    .step-content {
        margin-bottom: 23px;
    }
    .tags {
        margin-top: -23px;
        padding-left: 35px;
    }

    .tag {
        margin-left: 10px;
    }

    .no-padding-right {
        padding-right: 0;
    }
</style>



// WEBPACK FOOTER //
// supplierProtocol.vue?20f47479